import React, {ReactNode} from "react";
import AbstractAnnotation, {AbstractAnnotationProperties} from "./AbstractAnnotation";
import AnnotationRectangle from "./AnnotationRectangle";
import {
	Annotation,
	MetadataRectangle, Positions,
	AnnotationRectangle as MetadataAnnotationRectangle, Markup
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import {SVG_NAMESPACE} from "../../../../shared/annotation/Annotation";
import FunctionHelper from "../../../../shared/helper/FunctionHelper";

export class UnderlineAnnotation extends AbstractAnnotation<AbstractAnnotationProperties> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let annotation: Annotation = Annotation.fromJson(this.props.annotation.get());
		let color: string = FunctionHelper.applyValue(annotation.color, "transparent");
		let opacity: number = FunctionHelper.applyValue(annotation.markup?.opacity, Markup.getOpacityDefault()) / 100;

		let positions: Array<Positions> = FunctionHelper.applyValue(
			annotation.positions, Annotation.getPositionsDefault()
		);
		let result: Array<ReactNode> = [];

		for (let position of positions) {
			if (!FunctionHelper.exists((position as MetadataAnnotationRectangle).rectangle)) {
				continue;
			}

			let rectBoundaries: MetadataRectangle = (position as MetadataAnnotationRectangle).rectangle!;

			result.push(
				<AnnotationRectangle {...this.props} {...rectBoundaries}
									 className={"annotation annotation-" + annotation.subType!.toLowerCase()}
									 popupCreator={annotation.markup?.creator} popupColor={color} key={result.length}
									 popupContent={annotation.contents} creationDate={annotation.markup?.creationDate}
									 style={{
										 zIndex: 0
									 }}>
					<svg xmlns={SVG_NAMESPACE}>
						<line x1={0} y1={rectBoundaries.height} x2={rectBoundaries.width}
							  y2={rectBoundaries.height} style={{
							opacity: opacity,
							stroke: color
						}}/>
					</svg>
				</AnnotationRectangle>
			);
		}

		return result;
	}
}